import {Injectable} from '@angular/core';
import {Observable, Subscriber} from 'rxjs';
import {ConfirmModalComponent} from '../../components/layout/confirm-modal/confirm-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {

  private confirmModalComponent: ConfirmModalComponent | null = null;

  setComponent(confirmModalComponent: ConfirmModalComponent): void {
    this.confirmModalComponent = confirmModalComponent;
  }

  open(message: string): Observable<boolean> {
    return new Observable<boolean>((subscriber: Subscriber<boolean>) => {
      this.confirmModalComponent?.open(message).subscribe((result: boolean) => {
        subscriber.next(result);
      });
    });
  }

}
